'use strict';

var _keys2 = _interopRequireDefault(require("lodash/keys"));

var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (darc) {
  var WriteOp = require('./../WriteOp');

  darc.addOperation({
    name: 'pop',
    args: [],
    description: '',
    inputs: 'T[]',
    extends: WriteOp,
    bubble: {
      update: function update(msg) {
        var count = this.$.args[0];

        if (darc.isMissing(count)) {
          count = 1;
        }

        msg.deltas = {
          $pop: count
        };
      }
    },
    process: {
      update: function update(element, count) {
        if ((0, _isPlainObject2.default)(element)) {
          var keys = (0, _keys2.default)(element);
          var primaryKeys = keys.slice(keys.length - count);
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = primaryKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var key = _step.value;
              delete element[key];
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return element;
        }

        while (isFinite(count) && count-- > 0 && element.length) {
          element.pop();
        }

        return element;
      }
    }
  });
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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